export interface HeatmapColorPalette {
  red: string;
  yellow: string;
  green: string;
}

/**
 * Returns heatmap cell color for a score value (0-1): red → yellow → green.
 */
export function getHeatmapCellColor(scoreValue: number, palette: HeatmapColorPalette): string {
  const v = Math.max(0, Math.min(1, scoreValue));
  if (v <= 0.5) {
    return interpolateHexColor(palette.red, palette.yellow, v * 2);
  }
  return interpolateHexColor(palette.yellow, palette.green, (v - 0.5) * 2);
}

/**
 * Interpolates between two hex colors. t=0 returns hex1, t=1 returns hex2.
 */
export function interpolateHexColor(hex1: string, hex2: string, t: number): string {
  if (!/^#[0-9a-fA-F]{6}$/.test(hex1)) return hex2;
  if (!/^#[0-9a-fA-F]{6}$/.test(hex2)) return hex1;
  const r1 = parseInt(hex1.slice(1, 3), 16);
  const g1 = parseInt(hex1.slice(3, 5), 16);
  const b1 = parseInt(hex1.slice(5, 7), 16);
  const r2 = parseInt(hex2.slice(1, 3), 16);
  const g2 = parseInt(hex2.slice(3, 5), 16);
  const b2 = parseInt(hex2.slice(5, 7), 16);
  const r = Math.round(r1 + (r2 - r1) * t);
  const g = Math.round(g1 + (g2 - g1) * t);
  const b = Math.round(b1 + (b2 - b1) * t);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
